import DataAsesmenRalan from "@/services/DataAsesmenRalan";
import { IdentitasPasien } from "@/types";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { appModule } from "./app";
import DataAssesmenPenunjang from "@/services/DataAssesmenPenunjang";
import DataPemeriksaanFisikRalan from "@/services/DataPemeriksaanFisikRalan";

interface PemeriksaanFisikRalanRalan {
  unit_id: number;
  register_id: number;
  tanda_vital: object;
  antropometri: object;
  nyeri: object;
}


@Module({ store, dynamic: true, name: "storePemeriksaanFisikRalan" })
class StorePemeriksaanFisikRalan extends VuexModule {
  pemeriksaanfisikralan = {} as PemeriksaanFisikRalanRalan;

  @Mutation SET_PEMERIKSAAN_FISIK_RALAN(pemeriksaanfisikralan: PemeriksaanFisikRalanRalan) {
    this.pemeriksaanfisikralan = pemeriksaanfisikralan;
  }

  @Action clear() {
    this.SET_PEMERIKSAAN_FISIK_RALAN({} as PemeriksaanFisikRalanRalan);
  }

  @Action actPemeriksaanFisikRalan(param) {
    const dt = DataPemeriksaanFisikRalan.getDataPemeriksaanFisikRalan(param["unit_id"], param["reg"]);
    appModule.setLoading(true);
    dt.then(dt => {
      appModule.setLoading(false);
      const detail = dt.data
      this.SET_PEMERIKSAAN_FISIK_RALAN(detail)
    });
  }
}

export const storePemeriksaanFisikRalan = getModule(StorePemeriksaanFisikRalan);
